import { connect } from 'react-redux';
import get from 'lodash.get';
import React from 'react';
import PropTypes from 'prop-types';

import { getSelectedSelfServiceAnswer } from 'app/modules';
import IconContainer from 'presentation/components/icons/IconContainer';
import overrideStyle from 'lib/overrideStyle';

const SelectedAnswerItem = overrideStyle('div')`
  background-color: #F9F9F9;
  font-size: 13px;
  font-weight: normal;
  padding: 15px 25px;
`;

const SelectedAnswerItemText = overrideStyle('div')`
  align-items: center;
  background-color: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #D2D2D2;
  display: flex;
  height: 50px;
  justify-content: start;
  margin-top: 10px;
  padding: 0 20px;
`;

const BookIconStyles = overrideStyle('div')`
  padding-right: 10px;
  width: 12px;
`;

function SelectedAnswerHistoryItem(props) {
  SelectedAnswerHistoryItem.PropTypes = {
    name: PropTypes.string,
  };

  if (!!props.name) {
    return (
      <SelectedAnswerItem>
        You looked at
        <SelectedAnswerItemText>
          {book}
          {props.name}
        </SelectedAnswerItemText>
      </SelectedAnswerItem>
    );
  } else {
    return null;
  }
}

const book = (
  <BookIconStyles>
    <IconContainer viewBox="0 0 448 512">
      <path
        fill="currentColor"
        d="M356 160H188c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zm12 52v-8c0-6.6-5.4-12-12-12H188c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12zm64.7 268h3.3c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H80c-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0h344c13.3 0 24 10.7 24 24v368c0 10-6.2 18.6-14.9 22.2-3.6 16.1-4.4 45.6-.4 65.8zM128 384h288V32H128v352zm-96 16c13.4-10 30-16 48-16h16V32H80c-26.5 0-48 21.5-48 48v320zm372.3 80c-3.1-20.4-2.9-45.2 0-64H80c-64 0-64 64 0 64h324.3z"
      />
    </IconContainer>
  </BookIconStyles>
);

const mapStateToProps = state => {
  return {
    name: get(getSelectedSelfServiceAnswer(state), 'name'),
  };
};

const SelectedAnswerHistoryItemContainer = connect(mapStateToProps)(SelectedAnswerHistoryItem);

export default SelectedAnswerHistoryItemContainer;
